export default __webpack_public_path__ + "static/media/Snd_Try6.51ebe3d5.mp3";